<ngx-masonry [options]="masonryOptions" [ordered]="true">
  <div class="grid-sizer w-full md:w-[50%] lg:w-[25%]"></div>
  @for (item of items; track item) {
    @if (hasPermission(item)) {
      <div class="masonry-item w-full md:w-[50%] lg:w-[25%]" ngxMasonryItem>
        @if (mode === 'default') {
          <cat-dashboard-card-item (search)="search.emit($event)"
          [item]="item"></cat-dashboard-card-item>
        }
        @if (mode === 'simple') {
          <cat-dashboard-simple-card-item (search)="search.emit($event)"
            [item]="item"
          [settings]="simpleSettings"></cat-dashboard-simple-card-item>
        }
      </div>
    }
  }
</ngx-masonry>
